<template>
    <div class="instrumentTime">
        <div class="layout-page-box">
            <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
                <el-form-item label="字段名称">
                    <el-select v-model.trim="filters.managementType" clearable placeholder="选择字段名称">
                        <el-option v-for="(item) in names" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="员工姓名">
                    <el-select @focus="focus" filterable remote :filter-method="empMatch" v-model="filters.empNameNo" placeholder="请选择医生" style="width:95%;" clearable>
                        <el-option v-for="(item) in newData" :key="item.id" :label="item.empName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否挂靠">
                    <el-select v-model.trim="filters.attachment" placeholder="请选择是否挂靠" clearable>
                        <el-option v-for="(item) in ranks" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="挂靠方式">
                    <el-select v-model.trim="filters.attachmentMode" placeholder="请选择挂靠方式" clearable>
                        <el-option v-for="(item) in ways" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="挂靠人">
                    <el-select @focus="focus" filterable remote :filter-method="empMatch" v-model.trim="filters.attachmentNameNo" placeholder="请选择挂靠人" clearable>
                        <el-option v-for="(item) in newData" :key="item.id" :label="item.empName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search" size="small">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="buttonText">
                <!-- <div class="delete" @click="delAll">批量删除</div>
                <div class="addData" @click="add">新增</div> -->
                <el-button type="warning" @click="add" icon="el-icon-plus">新增</el-button>
                <el-button type="danger" @click="delAll" icon="el-icon-delete">批量删除</el-button>
            </div>
        </div>
        <div class="layout-page-box">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="id" label="编号" align="center"></el-table-column>
                <el-table-column sortable prop="managementType" label="字段名称">
                    <template slot-scope="scope">
                        <span v-if="scope.row.managementType==15">注射医生、医生姓名</span>
                        <span v-if="scope.row.managementType==16">护士姓名、当班护士</span>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="empName" label="姓名"></el-table-column>
                <el-table-column sortable prop="attachment" label="是否挂靠">
                    <template slot-scope="scope">
                        <span v-if="scope.row.attachment==0">否</span>
                        <span v-if="scope.row.attachment==1">是</span>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="attachmentMode" label="挂靠方式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.attachmentMode==0">/</span>
                        <span v-if="scope.row.attachmentMode==1">()</span>
                    </template>
                </el-table-column>
                <el-table-column sortable prop="attachmentName" label="挂靠人"></el-table-column>
                <el-table-column sortable prop="remark" label="备注"></el-table-column>
                <el-table-column sortable prop="createBy" label="添加人"></el-table-column>
                <el-table-column sortable prop="createTime" label="添加时间"></el-table-column>
                <el-table-column align="center" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
            </el-pagination>
        </div>
        <!-- 新增编辑身份弹框 -->
        <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
            <el-form :model="formData" label-width="100px">
                <el-form-item label="字段名称">
                    <el-select v-model.trim="formData.managementType" clearable placeholder="选择字段名称" style="width:95%;">
                        <el-option v-for="(item) in names" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-select @focus="focus" filterable remote :filter-method="empMatch" ref="empName" v-model="formData.empNameNo" placeholder="请选择医生" style="width:95%;" clearable>
                        <el-option v-for="(item) in newData" :key="item.id" :label="item.empName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否挂靠">
                    <el-select @change="attachChange" v-model="formData.attachment" placeholder="请选择是否挂靠" style="width:95%;" clearable>
                        <el-option v-for="(item) in ranks" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="挂靠方式">
                    <el-select :disabled="disabled" v-model="formData.attachmentMode" placeholder="请选择挂靠方式" style="width:95%;" clearable>
                        <el-option v-for="(item) in ways" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="挂靠人">
                    <el-select @focus="focus" filterable remote :filter-method="empMatch" :disabled="disabled" multiple ref="attachmentName" v-model="formData.attachmentNameNo" placeholder="请选择挂靠人" style="width:95%;" clearable>
                        <el-option v-for="(item) in newData" :key="item.id" :label="item.empName" :value="item.id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model.trim="formData.remark" style="width:95%;" clearable>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer partFooter">
                <el-button type="danger" @click="dialogFormVisible=false">取 消</el-button>
                <el-button type="primary" @click="doAddgoods()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, } from 'vuex'

export default {
    name: 'skinSetEmployee',
    computed: {
        ...mapState(['areaOptions']),
    },
    data() {
        return {
            filters: {
                types: '',
                pagination: {
                    page: 1,
                    limit: 10,
                    total: 0
                },
                startTime: '',
                endTime: '',
            },
            tableData: [],
            multipleSelection: [],
            dialogFormVisible: false,
            formData: {},
            ways: [
                { name: '/', id: 0 },
                { name: '()', id: 1 },
            ],
            tableHeight: '',
            ranks: [
                {
                    name: '是',
                    id: 1,
                }, {
                    name: '否',
                    id: 0,
                }
            ],
            names: [
                {
                    id: 15,
                    name: '注射医生、医生姓名',
                },
                {
                    id: 16,
                    name: '护士姓名、当班护士',
                },
            ],
            people: [],
            newData: [],
            disabled: false,
        }
    },
    created() {
        this.tableHeight = document.documentElement.clientHeight - 380
        api.requestQuiet("/identity/findIdentityMenuList", {
            departmentCode: '003'
        }, (res) => {
            this.people = res.data
            this.newData = this.people
        }, (err) => { });
    },
    mounted() {
        /*this.init();*/
        this.query(this.filters.pagination.page);
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.query(this.filters.pagination.page);
            }
        },
    },
    methods: {
        focus() {
            api.request("/identity/findIdentityMenuList", {
                departmentCode: '003'
            }, (res) => {
                this.people = res.data
                this.newData = this.people
            }, (err) => { });
        },
        empMatch(val) {
            this.newData = _g.paramMatch(this.people, this.newData, val, 'empName')
        },
        search() {
            this.filters.pagination.page = 1
            this.refresh()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        pageChanged(page) {
            this.filters.pagination.page = page
            this.refresh()
        },
        handleSizeChange(sizes) {
            this.filters.pagination.limit = sizes
            this.refresh()
        },
        refresh() {
            router.push({
                path: this.$route.path,
                query: _.merge({}, this.$route.query, {
                    __query: JSON.stringify(this.pagination)
                }, {
                        random: Math.random()
                    })
            })
        },

        handleEdit(index, row) {
            this.dialogFormVisible = true
            api.requestQuiet("/identity/findStaffManagementById", {
                id: row.id
            }, (res) => {
                this.formData = res.data
                this.formData.empNameNo = Number(this.formData.empNameNo)
                this.formData.attachment = Number(this.formData.attachment)
                this.formData.managementType = Number(this.formData.managementType)
                this.formData.attachmentMode = Number(this.formData.attachmentMode)
                if (this.formData.attachment == 0) {
                    this.disabled = true
                } else if (this.formData.attachment == 1) {
                    this.disabled = false
                }
            }, (err) => { });
        },
        // 新增项目
        add() {
            this.dialogFormVisible = true
            // 新增置空
            this.formData = {}
        },
        doAddgoods() {
            let arr = []
            this.people.forEach(item => {
                if (this.formData.attachmentNameNo) {
                    this.formData.attachmentNameNo.forEach(ele => {
                        if (item.id == ele) {
                            arr.push(item.empName)
                        }
                    });
                }
                if (item.id == this.formData.empNameNo) {
                    console.log(item);
                    this.formData.amt = item.amt
                    this.formData.outpatientServiceCode = item.outpatientServiceCode
                }
            });
            let querys = {
                id: this.formData.id,
                departmentName: '注射微整科',
                departmentCode: '003',
                empName: this.$refs.empName.selected.label,
                empNameNo: this.formData.empNameNo,
                managementType: this.formData.managementType,
                attachment: this.formData.attachment,
                amt: this.formData.amt,
                outpatientServiceCode: this.formData.outpatientServiceCode,
                attachmentMode: this.formData.attachmentMode,
                attachmentName: arr.toString(),
                attachmentNameNo: this.formData.attachmentNameNo ? this.formData.attachmentNameNo.toString() : '',
                createBy: Lockr.get('skinEmpId')
            }

            api.requestQuiet("/identity/createStaffManagement", querys, (res) => {
                if (res.result == true) {
                    this.dialogFormVisible = false
                    _g.toast("success", '操作成功');
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });
        },
        // 批量删除
        delAll() {
            var data = this.multipleSelection;
            var id = [];
            data.map(function (item, index) {
                console.log(item)
                id.push(item.id);
            });
            this.$confirm("确定要删除选中的数据吗？", "删除项目", {
                center: true,
            })
                .then((res) => {
                    api.requestQuiet(
                        "/identity/deleteStaffManagementAll", {
                            idList: id.toString(),
                        },
                        (res) => {
                            if (res.result == true) {
                                _g.toast("success", "删除成功");
                                this.query(this.filters.pagination.page);
                            } else {
                                _g.toast("error", "删除失败");
                                this.query(this.filters.pagination.page);
                            }
                        }
                    );
                })
                .catch((err) => {
                    // this.$message.error('删除失败！');
                });
        },
        // 查询数据列表
        query(page) {
            // console.log(this.filters.startTime)
            var querys = {
                startTime: '',
                endTime: '',
                page: page,
                size: this.filters.pagination.limit,
                empNameNo: this.filters.empNameNo,
                managementType: this.filters.managementType,
                attachment: this.filters.attachment,
                attachmentMode: this.filters.attachmentMode,
                attachmentNameNo: this.filters.attachmentNameNo,
                departmentCode: '003'
            }
            if (this.filters.startTime) {
                querys.startTime = this.filters.startTime[0]
                querys.endTime = this.filters.startTime[1]
            }
            // console.log(querys)
            api.request('/identity/findStaffManagementPage', querys, (res) => {
                // console.log(res)
                var data = res.data.list
                this.tableData = data
                this.filters.pagination.total = parseInt(res.data.count)
            })
        },
        attachChange(val) {
            if (val == 0) {
                this.disabled = true
            } else if (val == 1) {
                this.disabled = false
            }
        }
    },


}
</script>
<style scoped>
@import "../../assets/css/main.css";
</style>